// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#4484ce, #1ad7c0, #ff9b11, #9b59b6, #ff7f7f, #ecf0f1",
  firstName: "Jan Carlo",
  middleName: "",
  lastName: "Once",
  message: " Changing the world with technology one step at a time. ",
  icons: [
    {
      image: "fa-github",
      url: "https://github.com/jancarloonce/",
    },
    {
      image: "fa-facebook",
      url: "https://www.facebook.com/jancarlo.once/",
    },
    {
      image: "fa-instagram",
      url: "https://www.instagram.com/jancarlo.once/",
    },
    {
      image: "fa-linkedin",
      url: "https://www.linkedin.com/in/jan-carlo-once-468a8915b/",
    }
  ],
};

// ABOUT SECTION
// If you want the About Section to show a profile picture you can fill the profilePictureLink either with:
//a) your Instagram username
//      i.e:profilePictureLink:"johnDoe123",
//b) a link to an hosted image
//      i.e:profilePictureLink:"www.picturesonline.com/johnDoeFancyAvatar.jpg",
//c) image in "editable-stuff" directory and use require("") to import here,
//      i.e: profilePictureLink: require("../editable-stuff/iamge.png"),
//d) If you do not want any picture to be displayed, just leave it empty :)
//      i.e: profilePictureLink: "",
// For Resume either provide link to your resume or import from "editable-stuff" directory
//     i.e resume: require("../editable-stuff/resume.pdf"),
//         resume: "https://docs.google.com/document/d/13_PWdhThMr6roxb-UFiJj4YAFOj8e_bv3Vx9UHQdyBQ/edit?usp=sharing",

const about = {
  show: true,
  heading: "About Me",
  imageLink: require("../editable-stuff/profile.jpg"),
  imageSize: 375,
  message:
    "Seasoned Software Engineer with a passion for crafting inventive, scalable solutions across cloud, machine learning, data engineering, and web development. I thrive on complex challenges and delivering impactful results. Let's build something great together.",
  resume: require("../editable-stuff/resume.pdf"),
};

// PROJECTS SECTION
// Setting up project lenght will automatically fetch your that number of recently updated projects, or you can set this field 0 to show none.
//      i.e: reposLength: 0,
// If you want to display specfic projects, add the repository names,
//      i.e ["repository-1", "repo-2"]
const repos = {
  show: true,
  heading: "Recent Projects",
  gitHubUsername: "jancarloonce", //i.e."johnDoe12Gh"
  reposLength: 6,
  specificRepos: [],
  excludeRepos: []
};

// Leadership SECTION
const leadership = {
  show: false,
  heading: "Leadership",
  message:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae auctor eu augue ut lectus arcu bibendum at varius. Libero justo laoreet sit amet cursus sit amet. Imperdiet dui accumsan sit amet nulla facilisi morbi. At auctor urna nunc id. Iaculis urna id volutpat lacus laoreet non curabitur gravida. Et magnis dis parturient montes nascetur ridiculus mus mauris. In nisl nisi scelerisque eu ultrices vitae auctor. Mattis nunc sed blandit libero volutpat sed cras ornare. Pulvinar neque laoreet suspendisse interdum consectetur libero.",
  images: [
    {
      img: require("../editable-stuff/profile.jpg"),
      label: "First slide label",
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum."
    },
    {
      img: require("../editable-stuff/profile.jpg"),
      label: "Second slide label",
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum."
    },
  ],
  imageSize: {
    width: "615",
    height: "450"
  }
};

const skills = {
  show: true,
  heading: "Skills",
  technicalSkills: [
    {
      category: "Languages",
      skills: [
        { name: "Python" }, { name: "JavaScript" }, { name: "TypeScript" },
        { name: "Java" }, { name: "C#" }, { name: "Bash" }, { name: "Mojo" },
      ],
    },
    {
      category: "Web & API",
      skills: [
        { name: "React" }, { name: "Next.js" }, { name: "FastAPI" },
        { name: "Django" }, { name: "Flask" }, { name: "Spring Boot" },
        { name: "Redux" }, { name: "Pydantic" }, { name: "Gradio" },
        { name: "Tailwind CSS" },
      ],
    },
    {
      category: "Cloud & DevOps",
      skills: [
        { name: "AWS" }, { name: "Azure" }, { name: "GCP" },
        { name: "Docker" }, { name: "Kubernetes" }, { name: "Git" },
        { name: "Linux" }, { name: "Nginx" }, { name: "Airflow" },
        { name: "OpenShift" },
      ],
    },
    {
      category: "Data & ML",
      skills: [
        { name: "Scikit-learn" }, { name: "PyTorch" }, { name: "TensorFlow" },
        { name: "LangChain" }, { name: "HuggingFace" }, { name: "OpenAI" },
        { name: "Sagemaker" }, { name: "Bedrock" }, { name: "FAISS" },
      ],
    },
    {
      category: "Databases & Storage",
      skills: [
        { name: "PostgreSQL" }, { name: "MySQL" }, { name: "MSSQL" },
        { name: "Elasticsearch" }, { name: "CosmosDB" }, { name: "ChromaDB" },
        { name: "Hive" }, { name: "Kafka" }, { name: "NiFi" }, { name: "Hadoop" },
      ],
    },
    {
      category: "Monitoring & Testing",
      skills: [
        { name: "Grafana" }, { name: "Kibana" }, { name: "Prometheus" },
        { name: "Splunk" }, { name: "Postman" }, { name: "Selenium" },
      ],
    },
  ],
  softSkills: [
    { name: "Goal-Oriented" }, { name: "Collaboration" }, { name: "Adaptability" },
    { name: "Problem Solving" }, { name: "Empathy" }, { name: "Organization" },
    { name: "Creativity" }, { name: "Attention to Detail" },
  ],
};


// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: "Get in Touch",
  message:
    "I'm currently looking for full-time Software Engineering or Machine Learning opportunities! If you know of any positions available, if you have any questions, or if you just want to say hi, please feel free to email me at",
  email: "jancarloonce11@gmail.com",
};

const experiences = {
  show: false,
  heading: "Experiences",
  data: [
    {
      role: 'Software Engineer',// Here Add Company Name
      companylogo: require('../assets/img/adaca.png'),
      date: 'January 2024 – Present',
      company: 'Adaca'

    },
    {
      role: 'Machine Learning Data Engineer',
      companylogo: require('../assets/img/odyssey.png'),
      date: 'November 2023 – December 2023',
      company: 'Odyssey'
    },
    {
      role: 'Application Developer',
      companylogo: require('../assets/img/ibm.png'),
      date: 'February 2019 – August 2023',
      company: 'IBM'
    },
    {
      role: 'Associate Software Engineer',
      companylogo: require('../assets/img/accenture.png'),
      date: 'May 2017 – January 2019',
      company: 'Accenture'
    },
  ]
}

const certificationsData = [
  {
    name: 'AWS AI Practitioner',
    issuer: 'Amazon Web Services',
    badgeUrl: 'https://www.credly.com/badges/122b2835-1784-4afd-94f1-5dc64b19518f',
    imageUrl: require('../assets/img/certs/aws ai practitioner.png'),
  },
  {
    name: 'AWS Cloud Practitioner',
    issuer: 'Amazon Web Services',
    badgeUrl: 'https://www.credly.com/badges/116132fc-231b-409e-99b9-11087f2fdcee',
    imageUrl: require('../assets/img/certs/aws cloud pratitioner.png'),
  },
  {
    name: 'Azure Fundamentals',
    issuer: 'Microsoft',
    badgeUrl: 'https://www.credly.com/badges/e6e35cba-4c30-49c2-9ab6-2bae8a79c5a0',
    imageUrl: require('../assets/img/certs/azure cloud fundamentals.png'),
  },
  {
    name: 'IBM Cloud Technical Advocate',
    issuer: 'IBM',
    badgeUrl: 'https://www.credly.com/badges/6bc303e2-7829-4549-946b-382ba204988d',
    imageUrl: require('../assets/img/certs/ibm cloud advocate Cognitive-Practitioner.png'),
  },
];



const timelineElements = {
  show: true,
  heading: "Experience",
  data: [
    {
      role: 'Data Engineer (AI/ML)',
      companylogo: require('../assets/img/ibm.png'),
      date: 'September 2025 – Present',
      company: 'IBM',
      location: 'Quezon City, Philippines',
    },
    {
      role: 'Senior Software Engineer',
      companylogo: require('../assets/img/adaca.png'),
      date: 'January 2024 – August 2025',
      company: 'Adaca',
      location: 'Sydney, Australia',
    },
    {
      role: 'Machine Learning Data Engineer',
      companylogo: require('../assets/img/odyssey.png'),
      date: 'November 2023 – December 2023',
      company: 'Odyssey',
      location: 'San Jose, California',
    },
    {
      role: 'Senior Software Engineer',
      companylogo: require('../assets/img/ibm.png'),
      date: 'February 2019 – August 2023',
      company: 'IBM',
      location: 'Quezon City, Philippines',
    },
    {
      role: 'Associate Software Engineer',
      companylogo: require('../assets/img/accenture.png'),
      date: 'May 2017 – February 2019',
      company: 'Accenture',
      location: 'Mandaluyong City, Philippines',
    },
  ]
}

// Blog SECTION
// const blog = {
//   show: false,
// };

export { navBar, mainBody, about, repos, skills, leadership, getInTouch, experiences, timelineElements, certificationsData };
